import { createEmitter } from 'utils/emitter';

// Whether the SSO magic link has minted an AMBOSS session this app run.
let established = false;
const sessionEmitter = createEmitter();

export const subscribeToAmbossSessionState = sessionEmitter.subscribe;

export function isAmbossSessionEstablished(): boolean {
  return established;
}

export function markAmbossSessionEstablished(): void {
  if (established) return;
  established = true;
  sessionEmitter.notify();
}

export function resetAmbossSessionState(): void {
  if (!established) return;
  established = false;
  sessionEmitter.notify();
}
